<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 107.569 108.71"
    :aria-labelledby="iconName"
    role="presentation"
  >
  <g id="Group_3418" data-name="Group 3418" transform="translate(-1258 -256.593)">
    <g :fill="iconColor" id="Group_3407" data-name="Group 3407" transform="translate(1258 256.593)">
      <g id="Group_3398" data-name="Group 3398" transform="translate(0 0)">
        <g id="Group_3397" data-name="Group 3397">
          <path id="Path_4320" data-name="Path 4320" d="M559.608,330.429v-29.2a3.166,3.166,0,0,0-6.333,0v29.2a11.438,11.438,0,1,0,6.333,0Zm-3.166,16.1a5.106,5.106,0,1,1,5.106-5.106A5.112,5.112,0,0,1,556.442,346.526Z" transform="translate(-532.43 -258.623)"/>
          <path id="Path_4321" data-name="Path 4321" d="M575.349,334.276v-49a15.281,15.281,0,0,0-30.561,0v49a24.012,24.012,0,1,0,30.561,0Zm-15.281,36.2A17.68,17.68,0,0,1,549.8,338.407a3.167,3.167,0,0,0,1.324-2.576V285.279a8.948,8.948,0,0,1,17.9,0v50.551a3.167,3.167,0,0,0,1.324,2.576,17.68,17.68,0,0,1-10.272,32.069Z" transform="translate(-536.056 -270)"/>
        </g>
        <rect id="Rectangle_711" data-name="Rectangle 711" width="10.2" height="4.533" rx="1.613" transform="translate(46.295 43.179)"/>
        <rect id="Rectangle_712" data-name="Rectangle 712" width="17.567" height="4.533" rx="1.613" transform="translate(46.295 53.06)"/>
      </g>
      <path id="Path_4322" data-name="Path 4322" d="M582.385,282.011c-.385-.566-.739-1.1-1.072-1.6l-.454-.686a2.125,2.125,0,0,0-.571-.559,1.917,1.917,0,0,0-2.655.6c-.423.683-.912,1.4-1.5,2.25-3.4,4.989-6.713,10.147-6.713,13.558a9.84,9.84,0,0,0,19.681-.034C589.1,291.867,585.059,285.936,582.385,282.011ZM579.3,301.052h-.036a5.716,5.716,0,0,1-4.021-1.649,5.655,5.655,0,0,1-1.65-4.021c0-2.3,3.526-7.534,5.669-10.7l.173.26c2.057,3.068,5.5,8.2,5.5,10.443a5.725,5.725,0,0,1-1.651,4.026A5.658,5.658,0,0,1,579.3,301.052Z" transform="translate(-522.532 -266.408)"/>
    </g>
  </g>
  </svg>
</template>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
